import React, { useContext } from 'react';
import { ButtonPrimary } from '../../../StyledComponent';

import { ReactComponent as CardIcon } from '../../../../assets/novosicones/Financeiro/card.svg';
import { ContextPagamentoCartao } from '../../../../services/pagamentoCartao';

export default function BotaoCartao({
  tema,
  fullWidth,
  parcelas,
  width,
  light,
  disabled,
}) {
  const { setParcelasCardPayment, handleOpenModalCardPayment } = useContext(
    ContextPagamentoCartao
  );

  const handleCardPayment = () => {
    setParcelasCardPayment(parcelas);
    handleOpenModalCardPayment();
  };
  return (
    <ButtonPrimary
      width={width}
      fullWidth={fullWidth}
      tema={tema}
      light={light}
      onClick={handleCardPayment}
      id='btnPagarComCartao'
      disabled={disabled}
    >
      <CardIcon />
      CARTÃO
    </ButtonPrimary>
  );
}
